import { mmToPixels } from './Units';
const FALLBACK_SIZE_MM = { width: 148, height: 210 };
/**
 * The sign's true size in scene pixels (96 DPI), derived from the stored mm size.
 *
 * Replaces `canvas.width / canvas.getZoom()`, which only worked while the canvas
 * element was the sign and `getZoom()` was the fit ratio rather than a real camera.
 */
export const getArtboardSize = (canvas) => {
    const size = (canvas === null || canvas === void 0 ? void 0 : canvas.get('canvasSize')) || FALLBACK_SIZE_MM;
    return {
        width: mmToPixels(size.width),
        height: mmToPixels(size.height),
    };
};
/** The artboard sits at scene origin, so its rect is always anchored at (0, 0). */
export const getArtboardRect = (canvas) => {
    const { width, height } = getArtboardSize(canvas);
    return { left: 0, top: 0, right: width, bottom: height, width, height };
};
export const getArtboardCenter = (canvas) => {
    const { width, height } = getArtboardSize(canvas);
    return { x: width / 2, y: height / 2 };
};
